import { render, staticRenderFns } from "./InputTagDropdownAirportLocal.vue?vue&type=template&id=448ac972&scoped=true"
import script from "./InputTagDropdownAirportLocal.vue?vue&type=script&lang=js"
export * from "./InputTagDropdownAirportLocal.vue?vue&type=script&lang=js"
import style0 from "./InputTagDropdownAirportLocal.vue?vue&type=style&index=0&id=448ac972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ac972",
  null
  
)

export default component.exports